import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./style/style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./components/login";
import Register from "./components/register";
import UserPassword from "./components/setpassword";
import Layout from "./components/layout";
import Dashboard from "./components/dashboard";
import SubmitArticle from "./components/submitarticle";
import ProtectedRouters from "./ProtectedRoutes/ProtectedRoutes";
import CreateNewArticle from "./components/createnewarticle";
import DashboardContent from "./components/contentmanagement/dashboard";
import Manuscript from "./components/contentmanagement/manuscript";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import ViewProfile from "./components/viewprofile";
import UserManagement from "./components/usermanagement/usermanagement";
import Newuser from "./components/usermanagement/newuser";
import Notification from "./components/notification";
import { connect } from "react-redux";
import SummaryDetails from "./components/usermanagement/summarydetails";
import useWebSocket from "react-use-websocket";
import { dispatchRefreshToken } from "./redux/action";
import Feedback from "./components/feedback";
import ManuscriptMailAccept from "./components/manuscriptMail/accept";
import ManuscriptMailReject from "./components/manuscriptMail/reject";
import Instruction from "./components/instruction";
import Journal from "./components/jounalandissue";
import Moveaticle from "./components/movearticle";
import AddAuthor from "./components/movearticle/addAuthor";
import Reviewermanuscript from "./components/contentmanagement/manuscript/reviewermanuscript";
import LangEDManuscript from "./components/contentmanagement/manuscript/langedmanuscript";
import AutostructuringFailure from "./components/contentmanagement/manuscript/autostructingfailure";

interface Message {
  type: string;
  groupName: string;
  content?: string;
}

function App(props: any) {
  const { isAuthenticated, roleid } = props;
  const WS_URL: string = process.env.REACT_APP_WS_URL || "";
  const { sendJsonMessage, lastMessage } = useWebSocket(WS_URL, {
    share: true,
    onOpen: () => console.log("WebSocket connection opened."),
    onClose: () => console.log("WebSocket connection closed."),
    onError: (event) => console.error("WebSocket error:", event),
    shouldReconnect: (closeEvent) => true,
  });

  const sendJoinMessage = () => {
    const joinMessage: Message = {
      type: "join",
      groupName: roleid === 1 ? props.userInfo.userid : "Editors",
    };
    sendJsonMessage(joinMessage);
  };

  useEffect(() => {
    if (isAuthenticated && roleid !== null) {
      sendJoinMessage();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ✅ Global redirect logic (Handles all pages + special accept/reject)
  useEffect(() => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const id = url.searchParams.get("id");
    const newBase = "https://peerease.integra.co.in";

    // If manuscript accept/reject link → redirect with ID
    if (currentUrl.includes("/manuscriptaccept") && id) {
      window.location.href = `${newBase}/manuscriptaccept?id=${id}`;
      return;
    } else if (currentUrl.includes("/manuscriptreject") && id) {
      window.location.href = `${newBase}/manuscriptreject?id=${id}`;
      return;
    }

    // All other pages redirect to the new base domain
    window.location.href = `${newBase}/`;
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Your mail-triggered routes */}
        <Route path="/manuscriptaccept" element={<ManuscriptMailAccept />} />
        <Route path="/manuscriptreject" element={<ManuscriptMailReject />} />
        <Route path="/autostructuringfailure" element={<AutostructuringFailure />} />
        <Route path="/instruction" element={<Instruction />} />
        <Route path="/forgot" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Unauthenticated routes */}
        {!isAuthenticated ? (
          <>
            <Route path="/" element={<Instruction />} />
            <Route path="/login" element={<Login />} />
            <Route path="/password/:optionalParam" element={<UserPassword />} />
            <Route path="/feedback" element={<Feedback />} />
          </>
        ) : (
          <>
            {/* Role-based routes */}
            {roleid === 1 ? (
              <Route
                element={
                  <Layout
                    refresh={lastMessage?.data}
                    autogenerate={Math.floor(Math.random() * 1000)}
                  />
                }
              >
                <Route index path="/dashboard" element={<Dashboard />} />
                <Route path="/submitarticle" element={<SubmitArticle />} />
                <Route path="/createnewarticle" element={<CreateNewArticle />} />
                <Route path="/authorprofile" element={<Register />} />
                <Route path="/notification" element={<Notification />} />
              </Route>
            ) : roleid === 2 ? (
              <Route
                element={
                  <Layout
                    refresh={lastMessage?.data}
                    autogenerate={Math.floor(Math.random() * 1000)}
                  />
                }
              >
                <Route path="/dashboardcontent" element={<DashboardContent />} />
                <Route path="/viewprofile" element={<ViewProfile />} />
                <Route path="/journalandissue" element={<Journal />} />
                <Route path="/movearticle" element={<Moveaticle />} />
                <Route path="/addAuthor" element={<AddAuthor />} />
                <Route path="/manuscript" element={<Manuscript />} />
                <Route path="/usermanagement" element={<UserManagement />} />
                <Route path="/newuser" element={<Newuser />} />
                <Route path="/notification" element={<Notification />} />
                <Route path="/summarydetails" element={<SummaryDetails />} />
                <Route path="/feedback" element={<Feedback />} />
              </Route>
            ) : roleid === 4 ? (
              <Route
                element={
                  <Layout
                    refresh={lastMessage?.data}
                    autogenerate={Math.floor(Math.random() * 1000)}
                  />
                }
              >
                <Route path="/langedmanuscript" element={<LangEDManuscript />} />
                <Route path="/viewprofile" element={<ViewProfile />} />
                <Route path="/notification" element={<Notification />} />
              </Route>
            ) : (
              <Route
                element={
                  <Layout
                    refresh={lastMessage?.data}
                    autogenerate={Math.floor(Math.random() * 1000)}
                  />
                }
              >
                <Route path="/reviewermanuscript" element={<Reviewermanuscript />} />
                <Route path="/viewprofile" element={<ViewProfile />} />
                <Route path="/notification" element={<Notification />} />
              </Route>
            )}

            {/* Default & fallback routes */}
            <Route
              path="/"
              element={
                <Navigate
                  to={
                    roleid === 1
                      ? "/submitarticle"
                      : roleid === 3
                      ? "/reviewermanuscript"
                      : roleid === 4
                      ? "/langedmanuscript"
                      : "/manuscript"
                  }
                  replace
                />
              }
            />
            <Route
              path="*"
              element={
                <Navigate
                  to={
                    roleid === 1
                      ? "/submitarticle"
                      : roleid === 3
                      ? "/reviewermanuscript"
                      : roleid === 4
                      ? "/langedmanuscript"
                      : "/manuscript"
                  }
                  replace
                />
              }
            />
          </>
        )}

        {/* Protected Routes for unauthorized users */}
        {!isAuthenticated ? (
          <Route element={<ProtectedRouters />}>
            <Route
              element={
                <Layout
                  refresh={lastMessage?.data}
                  autogenerate={Math.floor(Math.random() * 1000)}
                />
              }
            >
              <Route index path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboardcontent" element={<DashboardContent />} />
              <Route path="/submitarticle" element={<SubmitArticle />} />
              <Route path="/createnewarticle" element={<CreateNewArticle />} />
              <Route path="/viewprofile" element={<ViewProfile />} />
              <Route path="/manuscript" element={<Manuscript />} />
              <Route path="/usermanagement" element={<UserManagement />} />
              <Route path="/newuser" element={<Newuser />} />
              <Route path="/authorprofile" element={<Register />} />
              <Route path="/notification" element={<Notification />} />
              <Route path="/summarydetails" element={<SummaryDetails />} />
            </Route>
          </Route>
        ) : (
          <></>
        )}
      </Routes>
    </BrowserRouter>
  );
}

const mapStateToProps = (state: any) => {
  return {
    isAuthenticated: state.rootReducer.authReducer.isLoggedIn,
    roleid: state.rootReducer.authReducer.userInfo?.roles?.[0]?.roleid ?? null,
    isToken: state.rootReducer.authReducer.token,
    refreshToken: state.rootReducer.authReducer.refreshToken,
    userInfo: state.rootReducer.authReducer.userInfo,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    dispatchRefreshToken: (refreshToken: any) => {
      dispatchRefreshToken(dispatch, refreshToken);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
